import { MedplumClient } from "@medplum/core";
const WS_URL = "wss://api-stage.healthconnect.systems/ws/subscriptions-r4";

export const fetchCommunicationResource = async (medplum: MedplumClient, qtrResponseID: any) => {
  let queryString =
    `_count=100&_offset=0&_sort=-_lastUpdated&_total=accurate&based-on=QuestionnaireResponse/${qtrResponseID}`;
  const communication = await medplum.searchResources("Communication", queryString)
  return communication.reverse();


}

export const extractMessages = (data: any, qResObj: any) => {
  const extData = data.map((item: any) => {
    const id = item.id;
    const sender = item.sender.reference;
    const message = item.payload[0].contentString;
    const lastUpdated = item.meta.lastUpdated;
    
    const isGenerated = sender?.includes("Device") && qResObj.length > 0 && !qResObj.find((ob:any) => message == ob?.questionText);
    const isRecalled = item?.note?.find((nt: any) => nt.text?.includes("re-called")) ? true: false;
    return { sender, message, lastUpdated, isGenerated, id, isRecalled };
  });

  return extData;
}
export function updatePhoneNumber(patientObject: any, newPhoneNumber: any) {
  if (patientObject.telecom && Array.isArray(patientObject.telecom)) {
    for (let telecom of patientObject.telecom) {
      if (telecom.system === "phone" && telecom.use === "home") {
        telecom.value = newPhoneNumber;
        break;
      }
    }
  }
  return patientObject;
}


export function connectQnrResSocket(ws: React.MutableRefObject<WebSocket | null>, setQnrResponse: React.Dispatch<any>, token: string, ) {
  ws.current = new WebSocket(WS_URL);
  ws.current.onopen = async () => {
    ws.current?.send(
      JSON.stringify({ type: "bind-with-token", payload: { token } })
    );
  };

  ws.current.onmessage = (event) => {
    const messageReceived = JSON.parse(event.data);
    const qnrRes = messageReceived?.entry?.find(
      (entry: any) => entry.resource.resourceType === "QuestionnaireResponse"
    );

    if (!qnrRes) return
    // upsert new  questionnaire response into response list  at the same index
    setQnrResponse((prev: any) => {
      const index = prev.findIndex((q: any) => q.id === qnrRes.resource.id);
      if (index === -1) {
        return ;
      } else {
        prev[index] = qnrRes.resource;
        return [...prev];
      }
    });
  }

  ws.current.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  ws.current.onclose = () => { };



}

export function connectCommSocket(ws: React.MutableRefObject<WebSocket | null>, setMessages: React.Dispatch<any>, token: string, qResObj: any) {
  ws.current = new WebSocket(WS_URL);
  ws.current.onopen = async () => {
    ws.current?.send(
      JSON.stringify({ type: "bind-with-token", payload: { token } })
    );
  };

  ws.current.onmessage = (event) => {
    const messageReceived = JSON.parse(event.data);
    // console.log(messageReceived, "messageReceived");
    const comm = messageReceived?.entry?.find(
      (entry: any) => entry.resource.resourceType === "Communication"
    );

    if (!comm) return
    setMessages((prev: any) => {
      const msgExist = prev.find((m: any) => m.id === comm.resource.id);
      if (msgExist) {
        return prev;
      }
      const formattedMsg = extractMessages([comm.resource], qResObj);
      return [...prev, ...formattedMsg];
    });
  }

  ws.current.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  ws.current.onclose = () => { };



}